import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addAnnouncement, announcementPushNotification, getAnnouncementsByID, getAnnouncementsList, updateAnnouncement } from "./AnnouncementRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

  export const useAnnouncementList = ({
    enabled,
    params={},
  }: {
    enabled: boolean;
    params?: Record<string, any>;
  }) => {
    return useQuery({
      queryKey: ["GET_ANNOUNCEMENTS_LIST", params],
      queryFn: () => getAnnouncementsList(params),
      enabled,
      retry: false,
    });
  };

   export const useAnnouncementByID = ({
    enabled,
    id,
  }: {
    enabled: boolean;
    id: number;
  }) => {
    return useQuery({
      queryKey: ["GET_ANNOUNCEMENTS_BY_ID", id],
      queryFn: () => getAnnouncementsByID(id),
      enabled,
      retry: false,
    });
  };

  export const useAddAnnouncement =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addAnnouncement(reqBody),
    
    
    onSuccess:(body)=>{
        showToast.success(body.message);
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet:", error.message)
    }
      
   })
} 

 export const useUpdateAnnouncement =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    
    
    mutationFn: ({ body, id }: { body: any; id: number }) => updateAnnouncement(body, id),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Announcement:", error.message)
    }
      
   })
} 

 export const useAnnouncementPushNotification =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    
    
    mutationFn: (body: any) => announcementPushNotification(body),
    
    
    onSuccess:(response)=>{
        showToast.success(response.message);
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_ANNOUNCEMENTS_BY_ID"] });
    },
    onError:(error:any)=>{
    showToast.error( error.message)
    }
      
   })
}